import { NavLink } from "react-router-dom";

function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <div className="footer-title">Hope Foundation</div>
            <p>
              A people-first NGO committed to education, health, and dignity for every family we
              serve.
            </p>
          </div>
          <div>
            <div className="footer-title">Quick Links</div>
            <div className="footer-links">
              <NavLink to="/about">About Us</NavLink>
              <NavLink to="/projects">Projects</NavLink>
              <NavLink to="/get-involved">Get Involved</NavLink>
              <NavLink to="/donate">Donate</NavLink>
            </div>
          </div>
          <div>
            <div className="footer-title">Contact</div>
            <div className="footer-links">
              <span>12 Park Avenue, New Delhi</span>
              <span>+91 98 7000 2200</span>
              <span>hello@hopefoundation.org</span>
            </div>
          </div>
          <div>
            <div className="footer-title">Newsletter</div>
            <div className="footer-links">
              <span>Monthly impact stories and campaign updates.</span>
              <span>Subscribe at hello@hopefoundation.org</span>
            </div>
          </div>
        </div>
        <div className="footer-note">
          Built for community impact. Follow us on Instagram, LinkedIn, and YouTube.
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
